/**
 * 오시는 길 페이지
 */

import React from 'react';
import styled from '@emotion/styled';
import { MainLayout } from '../../../../shared/components';
import { theme } from '../../../../shared/styles/theme';
import { mediaQueries } from '../../../../shared/constants/breakpoints';
import { CHURCH_INFO } from '../../data/churchInfo';
import { NaverMap } from '../../../home/components';

interface LocationInfo {
  lat: number;
  lng: number;
  address: string;
  directions: string;
}

const PageContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: ${theme.spacing.xxxl} ${theme.spacing.lg};

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.xl} ${theme.spacing.md};
  }
`;

const PageTitle = styled.h1`
  font-size: ${theme.fontSizes.xxxl};
  font-weight: 700;
  color: ${theme.colors.primary};
  text-align: center;
  margin-bottom: ${theme.spacing.xl};
  font-family: ${theme.fonts.heading};

  ${mediaQueries.maxMobile} {
    font-size: ${theme.fontSizes.xxl};
  }
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: ${theme.spacing.lg};
  margin-bottom: ${theme.spacing.xl};
`;

const InfoCard = styled.div`
  background-color: ${theme.colors.hover};
  padding: ${theme.spacing.xl};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.sm};
`;

const InfoLabel = styled.h3`
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.textLight};
  margin-bottom: ${theme.spacing.sm};
  font-weight: 600;
`;

const InfoValue = styled.p`
  font-size: ${theme.fontSizes.lg};
  color: ${theme.colors.primary};
  font-weight: 700;
  line-height: 1.6;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 500px;
  border-radius: ${theme.borderRadius.lg};
  overflow: hidden;
  box-shadow: ${theme.shadows.lg};
  margin-bottom: ${theme.spacing.xl};

  ${mediaQueries.maxMobile} {
    height: 350px;
  }
`;

const DirectionsSection = styled.div`
  background-color: ${theme.colors.hover};
  padding: ${theme.spacing.xxl};
  border-radius: ${theme.borderRadius.lg};
  border-left: 4px solid ${theme.colors.secondary};

  ${mediaQueries.maxMobile} {
    padding: ${theme.spacing.xl} ${theme.spacing.lg};
  }
`;

const DirectionsTitle = styled.h3`
  font-size: ${theme.fontSizes.xl};
  font-weight: 700;
  color: ${theme.colors.primary};
  margin-bottom: ${theme.spacing.lg};
  font-family: ${theme.fonts.heading};
`;

const DirectionsList = styled.ul`
  list-style: none;
`;

const DirectionItem = styled.li`
  font-size: ${theme.fontSizes.md};
  line-height: 1.8;
  color: ${theme.colors.text};
  margin-bottom: ${theme.spacing.md};
  padding-left: ${theme.spacing.lg};
  position: relative;

  &::before {
    content: '📍';
    position: absolute;
    left: 0;
  }
`;

const ParkingInfo = styled.div`
  margin-top: ${theme.spacing.xl};
  padding: ${theme.spacing.lg};
  background-color: ${theme.colors.background};
  border-radius: ${theme.borderRadius.md};
`;

const ParkingTitle = styled.h4`
  font-size: ${theme.fontSizes.lg};
  font-weight: 700;
  color: ${theme.colors.secondary};
  margin-bottom: ${theme.spacing.sm};
`;

const ParkingText = styled.p`
  font-size: ${theme.fontSizes.md};
  color: ${theme.colors.text};
  line-height: 1.6;
`;

export const Location: React.FC = () => {
  const locationInfo = CHURCH_INFO.location;

  return (
    <MainLayout>
      <PageContainer>
        <PageTitle>오시는 길</PageTitle>

        <InfoGrid>
          <InfoCard>
            <InfoLabel>주소</InfoLabel>
            <InfoValue>경기도 성남시 수정구 위례광장로 19 <span style={{ whiteSpace: 'nowrap' }}>아이페리온 8층</span></InfoValue>
          </InfoCard>
          <InfoCard>
            <InfoLabel>교통편</InfoLabel>
            <InfoValue>{locationInfo.directions}</InfoValue>
          </InfoCard>
        </InfoGrid>

        <MapContainer>
          <NaverMap lat={locationInfo.lat} lng={locationInfo.lng} title="위례세움교회" />
        </MapContainer>

        <DirectionsSection>
          <DirectionsTitle>교통 안내</DirectionsTitle>
          <DirectionsList>
            <DirectionItem>
              <strong>지하철:</strong> 8호선 남위례역 하차 후 도보 5분
            </DirectionItem>
            <DirectionItem>
              <strong>버스:</strong> 남위례역.창곡교차로 하차 (231번, 3420번, 9200번)
            </DirectionItem>
            <DirectionItem>
              <strong>자가용:</strong> 경부고속도로 판교IC 이용, 위례신도시 방면
            </DirectionItem>
          </DirectionsList>

          <ParkingInfo>
            <ParkingTitle>🚗 주차 안내</ParkingTitle>
            <ParkingText>
              교회 지하주차장을 이용하실 수 있습니다.
            </ParkingText>
          </ParkingInfo>
        </DirectionsSection>
      </PageContainer>
    </MainLayout>
  );
};
